import styled from 'styled-components/macro';
import { Typography } from '@mui/material';

import { Grid, Paper } from 'components';

const Wrapper = styled(Grid)`
  align-self: center;
  padding-top: 24px;
  padding-bottom: 32px;
  ${(props) => props.theme.breakpoints.up('lg')} {
    padding-top: 150px;
    padding-bottom: 74px;
  }
`;

const Footprint = styled.div`
  padding: 32px 0 8px;
  display: flex;
  justify-content: space-around;
  color: ${({ theme }) => theme.palette.common.white};
  ${(props) => props.theme.breakpoints.up('lg')} {
    padding: 56px 0 16px;
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 40px;
`;

const Details = styled(Typography)`
  margin-bottom: 16px;
  font-weight: 500;
  ${(props) => props.theme.breakpoints.up('lg')} {
    margin-bottom: 8px;
  }
`;

const ButtonWrapper = styled.div`
  padding-top: 32px;
  position: relative;
  z-index: 3;
  display: flex;
  justify-content: center;
  ${(props) => props.theme.breakpoints.up('lg')} {
    padding-top: 56px;
  }
`;

const InsightsWrapper = styled.div`
  padding: 40px 28px 32px;
  max-width: 465px;
  margin: 0 auto;
  ${(props) => props.theme.breakpoints.up('md')} {
    margin: 0 auto 112px;
    padding: 60px 0 0;
  }
`;

const QuestionsWrapper = styled.div`
  ${(props) => props.theme.breakpoints.up('lg')} {
    padding: 100px 0 56px;
    max-width: 465px;
    margin: 0 auto;
  }
`;

const ComparableWrapper = styled.div`
  margin-bottom: 8px;
  ${(props) => props.theme.breakpoints.up('lg')} {
    margin-bottom: 16px;
  }
`;

const PaperWrapper = styled(Paper.RoundedTop)`
  background: linear-gradient(
    ${({ theme }) => `${theme.palette.common.white}`} 60%,
    ${({ theme }) => `${theme.palette.primary.main}`} 0%
  );
  ${(props) => props.theme.breakpoints.up('md')} {
    background: linear-gradient(
      ${({ theme }) => `${theme.palette.common.white}`} 473px,
      ${({ theme }) => `${theme.palette.primary.main}`} 0%
    );
  }
`;

export const TransactionDetails = {
  Details,
  Footprint,
  Info,
  Wrapper,
  ButtonWrapper,
  InsightsWrapper,
  QuestionsWrapper,
  ComparableWrapper,
  PaperWrapper,
};
